import React from "react";

const ContactInformationView = () => {
  return <>Contact Information</>;
};

export default ContactInformationView;